"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NS_IN_MS = exports.NS_IN_SEC = exports.SECONDS_IN_HOUR = exports.SECONDS_IN_MINUTE = exports.YEAR = exports.WEEK = exports.DAY = exports.HOUR = exports.MINUTE = exports.SECOND = exports.MS = void 0;
exports.nanos2millis = nanos2millis;
exports.durationToTimeString = durationToTimeString;
exports.formatDurationAsMinutesAndSeconds = formatDurationAsMinutesAndSeconds;
exports.MS = 1;
exports.SECOND = 1000 * exports.MS;
exports.MINUTE = 60 * exports.SECOND;
exports.HOUR = 60 * exports.MINUTE;
exports.DAY = 24 * exports.HOUR;
exports.WEEK = 7 * exports.DAY;
exports.YEAR = 365 * exports.DAY;
exports.SECONDS_IN_MINUTE = exports.MINUTE / exports.SECOND;
exports.SECONDS_IN_HOUR = exports.HOUR / exports.SECOND;
exports.NS_IN_SEC = 1e9;
exports.NS_IN_MS = 1e6;
function nanos2millis(nanos) {
    return Number(nanos / BigInt(exports.NS_IN_MS));
}
function durationToTimeString(seconds) {
    const durationInSeconds = Math.round(seconds) % 60;
    const durationInMinutes = Math.floor(Math.round(seconds) / 60) % 60;
    const durationInHours = Math.floor(Math.round(seconds) / 60 / 60);
    const paddedMinutes = durationInMinutes.toString().padStart(2, "0");
    const paddedSeconds = durationInSeconds.toString().padStart(2, "0");
    if (durationInHours > 0) {
        const paddedHours = durationInHours.toString().padStart(2, "0");
        return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
    }
    return `${paddedMinutes}:${paddedSeconds}`;
}
/**
 * Formats a duration in seconds as a string in the format "Xm Ys".
 */
function formatDurationAsMinutesAndSeconds(seconds) {
    if (seconds === null) {
        return null;
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
}
//# sourceMappingURL=time.js.map